import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/ui/PageHeader';
import WorkTimer from '../components/WorkTimer';

const Timer = () => (
  <Box>
    <PageHeader
      title="Work Timer"
      subtitle="Track time against a task and category. Entries are stored locally in this browser."
    />
    <WorkTimer />
  </Box>
);

export default Timer;
